import React from "react";

export type LayoutPortalState = {
  /**
   * The layout portal container.
   */
  leftContainer: React.RefObject<HTMLDivElement>;
  rightContainer: React.RefObject<HTMLDivElement>;
};

export const LayoutPortalContext = React.createContext<
  LayoutPortalState | undefined
>(undefined);

export default LayoutPortalContext;
